import React, { useRef } from "react"
import { toast } from "sonner"

import { useCreateMeetingRecording } from "@/hooks/api/meetings/recordings"

interface UseMeetingRecordingUploadOptions {
  onSuccess?: () => void
}

export function useMeetingRecordingUpload(meetingId: string, options?: UseMeetingRecordingUploadOptions) {
  const fileInputRef = useRef<HTMLInputElement>(null)
  const uploadMutation = useCreateMeetingRecording()

  const triggerFileSelection = () => {
    fileInputRef.current?.click()
  }

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    if (!file) return

    // Validate file type (audio or video)
    if (!file.type.startsWith("audio/") && !file.type.startsWith("video/")) {
      toast.error("Please select an audio or video file")
      return
    }

    // Upload the file
    uploadMutation.mutate(
      { meetingId, file },
      {
        onSuccess: () => {
          toast.success("Recording uploaded successfully")
          if (fileInputRef.current) {
            fileInputRef.current.value = ""
          }
          options?.onSuccess?.()
        },
      }
    )
  }

  const fileInputElement = (
    <input
      ref={fileInputRef}
      type="file"
      accept="audio/*,video/*"
      onChange={handleFileChange}
      style={{ display: "none" }}
    />
  )

  return {
    triggerFileSelection,
    fileInputElement,
    isUploading: uploadMutation.isPending,
  }
}
